import { createPager } from '../factories';

import { requestPhoenix } from './requestPhoenix';

type Params = {
  path: string;
  body: Record<string, unknown>;
};

// fetches all query data overcoming Phoenix's 500 items page size limitation
export async function requestPhoenixAllPages<Payload extends { objects?: unknown[]; totalCount: number }>({
  path,
  body,
}: Params) {
  const response = await requestPhoenix<Payload>({
    path,
    body: { ...body, pager: createPager({ pageIndex: 1, pageSize: MAX_PAGE_SIZE }) },
  });

  if (response.objects === undefined) response.objects = [];

  if (response.totalCount > MAX_PAGE_SIZE) {
    const responses = await Promise.all(
      Array.from({ length: Math.ceil(response.totalCount / MAX_PAGE_SIZE) - 1 }).map((_value, index) =>
        requestPhoenix<Payload>({
          path,
          body: { ...body, pager: createPager({ pageIndex: index + 2, pageSize: MAX_PAGE_SIZE }) },
        }),
      ),
    );

    responses.forEach((payload) => {
      // @ts-expect-error TODO Fix
      if (payload.objects) response.objects.push(...payload.objects);
    });
  }

  return response;
}

const MAX_PAGE_SIZE = 500;
